var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headers'),_c('keep-alive',{attrs:{"include":[
      //暂时去掉Gaikuang，早晚会加回来的
      'Ztzl',
      'Index',
      'Gzly',
      'Search',
      'MonList',
      'GonggaoList',
      'Maps',
    ]}},[_c('router-view')],1),_c('fotters')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }